export interface ISendNoteInitialValues {
  note: string;
}

export const sendNoteInitialValues: ISendNoteInitialValues = {
  note: '',
};
